import { LOCAL_STORAGE_KEYS } from "../constants/local-storage-keys";

export const baseURL = process.env.REACT_APP_SC_API_ENDPOINT;

export const get = async ({ url }) => {
  try {
    const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

    const response = await fetch(`${baseURL}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });

    return response.json();
  } catch (error) {
    console.error("Error making POST request", error);
  }
};

export const post = async ({ url, body, contentType }) => {
  try {
    const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

    const response = await fetch(`${baseURL}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": contentType || "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(body),
    });

    return response.json();
  } catch (error) {
    console.error("Error making POST request", error);
  }
};

export const postFormData = async ({ url, formData, contentType }) => {
  try {
    const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

    const response = await fetch(`${baseURL}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": contentType || "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: formData,
    });

    return response.json();
  } catch (error) {
    console.error("Error making POST request", error);
  }
};

export const postDownloadImage = async ({ url, body }) => {
  try {
    const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);

    const response = await fetch(`${baseURL}${url}`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });
    return response.blob();
  } catch (error) {
    console.error("Error making POST request", error);
  }
};
